import { useCallback, useMemo, useState } from 'react'

const useSwitch = (defaultOn = false) => {
  const [on, setOn] = useState(defaultOn)

  const open = useCallback(() => {
    setOn(true)
  }, [])

  const close = useCallback(() => {
    setOn(false)
  }, [])

  return useMemo(
    () => ({
      on,
      open,
      close,
    }),
    [close, on, open]
  )
}

export { useSwitch }
